import * as React from 'react';
import classnames from 'classnames';
import { Strong } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const PrescriptionCard = ({ children , hideTitle , className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('prescription-card', className)
    }, !hideTitle && /*#__PURE__*/ React.createElement(Strong, {
        variant: "caption-head"
    }, getLabel('products.glasses.configurator.footer.prescription.title')), /*#__PURE__*/ React.createElement("span", {
        className: "prescription-card__children"
    }, children));
};

export { PrescriptionCard };
//# sourceMappingURL=PrescriptionCard.js.map
